"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _dataGridContext = _interopRequireDefault(require("../../data-grid-context"));

var ViewSwitch = function ViewSwitch() {
  var _useContext = (0, _react.useContext)(_dataGridContext["default"]),
      setShowTable = _useContext.setShowTable,
      setShowCards = _useContext.setShowCards,
      hasCustomView = _useContext.hasCustomView,
      hasTableView = _useContext.hasTableView,
      showTable = _useContext.showTable,
      showCards = _useContext.showCards,
      hasDoItYourselfView = _useContext.hasDoItYourselfView,
      setShowDoItYourselfView = _useContext.setShowDoItYourselfView,
      showDoItYourselfView = _useContext.showDoItYourselfView;

  var hideThumbnailView = false;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      listView = _useState2[0],
      setListView = _useState2[1];

  var onClickListView = function onClickListView() {
    setListView(true);
    setShowTable(true);
    setShowCards(false);
    setShowDoItYourselfView(false);
  };

  var onClickCardView = function onClickCardView() {
    if (hasDoItYourselfView) {
      setShowDoItYourselfView(true);
    } else {
      setShowCards(true);
    }

    setListView(false);
    setShowTable(false);
  };

  (0, _react.useEffect)(function () {
    if (showCards || showDoItYourselfView) {
      setListView(false);
    } else {
      setListView(true);
    }
  }, [showTable, showCards, showDoItYourselfView]);
  return hasCustomView && hasTableView || hasDoItYourselfView && hasTableView ? /*#__PURE__*/_react["default"].createElement("div", null, !hideThumbnailView && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: onClickListView,
    color: listView ? 'primary' : undefined,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "data-grid-navbar-view-switch-list",
    dataElementId: "data-grid-navbar-view-switch-list"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "view_list"
  })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: onClickCardView,
    color: !listView ? 'primary' : undefined,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "data-grid-navbar-view-switch-card-button",
    dataElementId: "data-grid-navbar-view-switch-card-button"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "view_module"
  })))) : /*#__PURE__*/_react["default"].createElement("div", null);
};

ViewSwitch.propTypes = {};
var _default = ViewSwitch;
exports["default"] = _default;